@if (missingUserRole || notAuthorizedUserRole) {
    <app-info-box type="error">
        <div class="flex items-center gap-5">
            <mat-icon svgIcon="cancel-circle" />
            @if (missingUserRole) {
                Valid user role is required to continue
            }
            @if (notAuthorizedUserRole) {
                User is not allowed to see any application
            }
        </div>
    </app-info-box>
} @else {
    <app-loader type="overlay" />
}
